import React from 'react'

import DashboardInvoiceCard from '../../elements/DashboardInvoiceCard'
import { Icon } from 'app/elements/Icon'

import { Title, InvoiceList, Header, Span, Text, DesktopText, MobileText } from './styles'

import { title, desktopText, mobileText } from './data.json'

const DashboardInvoice = ({ currentAccountPlan, match, isPartner }) => {
  return (
    currentAccountPlan && (
      <section>
        <Header>
          <Title>{title}</Title>

          {!isPartner && (
            <Text to={`/minha-veloe/${match.params.id}/fatura`}>
              <DesktopText>{desktopText}</DesktopText>
              <MobileText>{mobileText}</MobileText>
              <Span>
                <Icon icon="right-arrow" width="8" height="13" viewBox="0 0 8 13" />
              </Span>
            </Text>
          )}
        </Header>
        <InvoiceList>
          <DashboardInvoiceCard currentAccountPlan={currentAccountPlan} />
        </InvoiceList>
      </section>
    )
  )
}

export default DashboardInvoice



// WEBPACK FOOTER //
// ./src/app/modules/DashboardInvoiceWidget/index.js